<template>
  <section>
    <v-alert type="info" :value="showInfo" transition="slide-x-transition">
      Compter toutes la monaie et les billets se trouvant dans la caisse.
      <br />
      Ne pas ajouter le pourboire dans ce que vous comptez!
    </v-alert>
    <v-row dense>
      <v-col cols="12" sm="4" :lg="showTotal ? 3 : 4">
        <v-row no-gutters dense>
          <span class="caption">Monaie</span>
        </v-row>
        <v-row no-gutters>
          <v-text-field
            filled
            class="no-before mb-1"
            hide-details
            dense
            :readonly="readOnly"
            :value="argent_5cent"
            type="number"
            min="0"
            step="1"
            label="0.05$"
            @change="e => updateProps('argent_5cent', Number(e))"
          ></v-text-field>
        </v-row>
        <v-row no-gutters>
          <v-text-field
            filled
            class="no-before mb-1"
            hide-details
            dense
            :readonly="readOnly"
            :value="argent_10cent"
            type="number"
            min="0"
            step="1"
            label="0.10$"
            @change="e => updateProps('argent_10cent', Number(e))"
          ></v-text-field>
        </v-row>
        <v-row no-gutters>
          <v-text-field
            filled
            class="no-before mb-1"
            hide-details
            dense
            :readonly="readOnly"
            :value="argent_25cent"
            type="number"
            min="0"
            step="1"
            label="0.25$"
            @change="e => updateProps('argent_25cent', Number(e))"
          ></v-text-field>
        </v-row>
        <v-row no-gutters>
          <v-text-field
            filled
            class="no-before mb-1"
            hide-details
            dense
            :readonly="readOnly"
            :value="argent_1dollar"
            type="number"
            min="0"
            step="1"
            label="1.00$"
            @change="e => updateProps('argent_1dollar', Number(e))"
          ></v-text-field>
        </v-row>
        <v-row no-gutters>
          <v-text-field
            filled
            class="no-before mb-1"
            hide-details
            dense
            :readonly="readOnly"
            :value="argent_2dollar"
            type="number"
            min="0"
            step="1"
            label="2.00$"
            @change="e => updateProps('argent_2dollar', Number(e))"
          ></v-text-field>
        </v-row>
      </v-col>
      <v-col cols="12" sm="4" :lg="showTotal ? 3 : 4">
        <v-row no-gutters>
          <span class="caption">Billet</span>
        </v-row>
        <v-row no-gutters>
          <v-text-field
            filled
            class="no-before mb-1"
            hide-details
            dense
            :readonly="readOnly"
            :value="argent_5dollar"
            type="number"
            min="0"
            step="1"
            label="5.00$"
            @change="e => updateProps('argent_5dollar', Number(e))"
          ></v-text-field>
        </v-row>
        <v-row no-gutters>
          <v-text-field
            filled
            class="no-before mb-1"
            hide-details
            dense
            :readonly="readOnly"
            :value="argent_10dollar"
            type="number"
            min="0"
            step="1"
            label="10.00$"
            @change="e => updateProps('argent_10dollar', Number(e))"
          ></v-text-field>
        </v-row>
        <v-row no-gutters>
          <v-text-field
            filled
            class="no-before mb-1"
            hide-details
            dense
            :readonly="readOnly"
            :value="argent_20dollar"
            type="number"
            min="0"
            step="1"
            label="20.00$"
            @change="e => updateProps('argent_20dollar', Number(e))"
          ></v-text-field>
        </v-row>
        <v-row no-gutters>
          <v-text-field
            filled
            class="no-before mb-1"
            hide-details
            dense
            :readonly="readOnly"
            :value="argent_50dollar"
            type="number"
            min="0"
            step="1"
            label="50.00$"
            @change="e => updateProps('argent_50dollar', Number(e))"
          ></v-text-field>
        </v-row>
        <v-row no-gutters>
          <v-text-field
            filled
            class="no-before mb-1"
            hide-details
            dense
            :readonly="readOnly"
            :value="argent_100dollar"
            type="number"
            min="0"
            step="1"
            label="100.00$"
            @change="e => updateProps('argent_100dollar', Number(e))"
          ></v-text-field>
        </v-row>
      </v-col>
      <v-col cols="12" sm="4" :lg="showTotal ? 3 : 4">
        <v-row no-gutters>
          <span class="caption">Rouleaux</span>
        </v-row>
        <v-row no-gutters>
          <v-text-field
            filled
            class="no-before mb-1"
            hide-details
            dense
            :readonly="readOnly"
            :value="rouleaux_5cent"
            type="number"
            min="0"
            step="1"
            label="0.05$"
            @change="e => updateProps('rouleaux_5cent', Number(e))"
          ></v-text-field>
        </v-row>
        <v-row no-gutters>
          <v-text-field
            filled
            class="no-before mb-1"
            hide-details
            dense
            :readonly="readOnly"
            :value="rouleaux_10cent"
            type="number"
            min="0"
            step="1"
            label="0.10$"
            @change="e => updateProps('rouleaux_10cent', Number(e))"
          ></v-text-field>
        </v-row>
        <v-row no-gutters>
          <v-text-field
            filled
            class="no-before mb-1"
            hide-details
            dense
            :readonly="readOnly"
            :value="rouleaux_25cent"
            type="number"
            min="0"
            step="1"
            label="0.25$"
            @change="e => updateProps('rouleaux_25cent', Number(e))"
          ></v-text-field>
        </v-row>
        <v-row no-gutters>
          <v-text-field
            filled
            class="no-before mb-1"
            hide-details
            dense
            :readonly="readOnly"
            :value="rouleaux_1dollar"
            type="number"
            min="0"
            step="1"
            label="1.00$"
            @change="e => updateProps('rouleaux_1dollar', Number(e))"
          ></v-text-field>
        </v-row>
        <v-row no-gutters>
          <v-text-field
            filled
            class="no-before mb-1"
            hide-details
            dense
            :readonly="readOnly"
            :value="rouleaux_2dollar"
            type="number"
            min="0"
            step="1"
            label="2.00$"
            @change="e => updateProps('rouleaux_2dollar', Number(e))"
          ></v-text-field>
        </v-row>
      </v-col>
      <v-col cols="12" lg="3" v-if="showTotal">
        <v-row no-gutters>
          <span class="caption">Total</span>
        </v-row>
        <v-row no-gutters>
          <v-text-field
            filled
            class="no-before mb-1"
            hide-details
            dense
            :readonly="readOnly"
            :value="total"
            type="number"
            min="0"
            step="1"
            suffix="$"
          ></v-text-field>
        </v-row>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import round10 from "round10";
export default {
  name: "TillCaisse",
  props: {
    argent_5cent: {
      type: Number,
      required: true
    },
    argent_10cent: {
      type: Number,
      required: true
    },
    argent_25cent: {
      type: Number,
      required: true
    },
    argent_1dollar: {
      type: Number,
      required: true
    },
    argent_2dollar: {
      type: Number,
      required: true
    },
    argent_5dollar: {
      type: Number,
      required: true
    },
    argent_10dollar: {
      type: Number,
      required: true
    },
    argent_20dollar: {
      type: Number,
      required: true
    },
    argent_50dollar: {
      type: Number,
      required: true
    },
    argent_100dollar: {
      type: Number,
      required: true
    },
    rouleaux_5cent: {
      type: Number,
      required: true
    },
    rouleaux_10cent: {
      type: Number,
      required: true
    },
    rouleaux_25cent: {
      type: Number,
      required: true
    },
    rouleaux_1dollar: {
      type: Number,
      required: true
    },
    rouleaux_2dollar: {
      type: Number,
      required: true
    },
    total: {
      required: true
    },
    valid: {
      type: Boolean,
      default: true
    },
    showInfo: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    showTotal: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateProps(type, value) {
      this.$emit(`update:${type}`, Math.floor(Number(value)));
      setTimeout(() => this.calculateTotal(), 100);
    },
    calculateTotal() {
      const total =
        this.argent_5cent * 0.05 +
        this.argent_10cent * 0.1 +
        this.argent_25cent * 0.25 +
        this.argent_1dollar * 1 +
        this.argent_2dollar * 2 +
        this.argent_5dollar * 5 +
        this.argent_10dollar * 10 +
        this.argent_20dollar * 20 +
        this.argent_50dollar * 50 +
        this.argent_100dollar * 100 +
        this.rouleaux_5cent * 2 +
        this.rouleaux_10cent * 5 +
        this.rouleaux_25cent * 10 +
        this.rouleaux_1dollar * 25 +
        this.rouleaux_2dollar * 50;
      this.$emit("update:total", round10.round10(Number(total), -2));
      this.$emit("update:valid", Number(total) > 0);
    }
  }
};
</script>

<style lang="scss" scoped></style>
